import { render, staticRenderFns } from "./track-order.vue?vue&type=template&id=36c98b46&scoped=true"
import script from "./track-order.vue?vue&type=script&lang=js"
export * from "./track-order.vue?vue&type=script&lang=js"
import style0 from "./track-order.vue?vue&type=style&index=0&id=36c98b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c98b46",
  null
  
)

export default component.exports